import { useEffect, useState } from "react";
import DocumentTitle from "react-document-title";
import CompetitionsService, {
	CompetitionType,
	CompetitionTypes,
	CompetitionsType,
	CompetitionsUsersType,
	CompetitionsUsersTypeElement,
} from "../../services/CompetitionsService";
import { Spinner, SpinnerSize, DefaultButton, PrimaryButton } from "@fluentui/react";
import styles from "./index.module.sass";
import { currencyNeutreFormatter } from "../../utils/numberFormatter";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import Auth from "../../Auth/Auth";
import PortfolioModelWalletService, {
	ModelSavingPlanSelector,
	ModelWallet,
	ModelWalletOptions,
	ModelWalletSelector,
} from "../../services/PortfolioModelWalletService";
import Select from "react-dropdown-select";
import ElementsService, {
	ElementAmountType,
} from "../../services/ElementsService";
import BackButton from "../../components/buttons/BackButton";
import { GenericMessageModalWithoutButton } from "../../components/Modals/GenericModal";
import SavingsPlanService from "../../services/SavingsPlanService";
import { ErrorModal } from "../../components/Modals/ErrorModal";
import CompetitionCardFromCompetition from "../../components/competitionCardFromCompetition/CompetitionCardFromCompetition";
import * as S from '../../components/ConvenienceTest/ConvenienceTest.style';
import { Toggle } from "@fluentui/react/lib/Toggle";
import { addCompetitionInLS, ICompetitionInfo } from "../../store/educationalcart/actions";
import { addCompetition, addCompetitionData, cartState } from "../../store/cart/actions";
import { useDispatch } from "react-redux";
import { CartModes } from "../Cart/CartScreen";
import { createurl } from "../../utils/createUrl";
import { ITableSPlansActive } from "../../components/SavePlans/types/SavePlansTypes";

interface PortfolioModel
{
	portfolioModelId?: number;
}

const CompetitionParticipate = () =>
{

	const [error, setError] = useState({ status: false, message: "" });
	const [loading, setLoading] = useState<boolean>(true);
	const [sending, setSending] = useState<boolean>(false);

	const location = useLocation();
	const state = location.state as PortfolioModel | undefined;

	const { competitionId } = useParams<any>();

	const [competition, setCompetition] = useState<CompetitionType>();
	const [elementsAmount, setElementsAmount] = useState<ElementAmountType>();
	const [isModal, setIsModal] = useState<boolean>(false);
	const [showModal, setShowModal] = useState<boolean>(false);
	const [selectedSavingPlan, setSelectedSavingPlan] = useState<number>();
	const [wantElements, setWantElements] =
		useState(false);
	const [haveError, setHaveError] = useState<boolean>(false);
	const [savingPlanModelPortfolios, setSavingPlanModelPortfolios] = useState<
		ModelWalletOptions[]
	>();
	const [savingsPlans, setSavingsPlans] = useState<ModelSavingPlanSelector[]>();
	const [savingsPlansWithData, setSavingsPlansWithData] = useState<ITableSPlansActive[]>();
	const [chargedModelPortfolio, setChargedModelPortfolio] = useState<boolean>(true);
	const [selectedModelPortfolio, setSelectedModelPortfolio] = useState<number>();


	const history = useHistory();
	const user = Auth.getUserProfile();
	const dispatch = useDispatch();

	useEffect(() =>
	{
		CompetitionsService.getCompetition(competitionId).then(
			(response: CompetitionType) =>
			{
				setCompetition(response);
			},
			(error: any) =>
			{
				setError({ status: true, message: error.response.data });
			}
		);
	}, []);

	useEffect(() =>
	{
		SavingsPlanService.getSavingsPlansAndStatus(user.id).then((res: any) =>
		{
			const savingPlans = res.filter((e: any) => e.status === 4 && e.type != 0);

			let spSavingPlans = savingPlans.map((savingPlan: ITableSPlansActive) => ({
				value: savingPlan.id,
				label: savingPlan.planName
			}));

			setSavingsPlans(spSavingPlans);
			setSavingsPlansWithData(savingPlans);

		}).finally(() =>
		{
			setLoading(false);
		});
	}, []);

	useEffect(() =>
	{

		if (selectedSavingPlan != undefined)
		{
			setChargedModelPortfolio(false);

			PortfolioModelWalletService.getModelWallets(selectedSavingPlan).then((modelPortfolio) =>
			{
				let spModelPortfolios = modelPortfolio.map((portfolio: ModelWallet) => ({
					value: portfolio.id,
					label: portfolio.name,
				}));

				setSavingPlanModelPortfolios(spModelPortfolios);

				if (state?.portfolioModelId != undefined)
				{
					var selected = spModelPortfolios.find(e => e.value == state?.portfolioModelId);
					if (selected != undefined)
					{
						setSelectedModelPortfolio(selected.value);
					}
				} else
				{
					setSelectedModelPortfolio(undefined);
				}
			})

			ElementsService.getElementsAmountBySavingsPlanIdCompetition(selectedSavingPlan).then((elementsAmountAux) =>
			{

				if (elementsAmountAux != "")
				{
					setElementsAmount(elementsAmountAux);
				} else
				{
					setElementsAmount(undefined);
				}
			}).finally(() =>
			{
				setChargedModelPortfolio(true);
			})

		} else
		{
			setSavingPlanModelPortfolios([]);
		}
	}, [selectedSavingPlan]);

	const formatDate = (date: string) =>
	{
		const [month, day, year] = date.split("/");
		return `${day}/${month}/${year}`;
	};


	function truncateHtml(html: string, limit: number): string
	{
		const textContent = html.replace(/<\/?[^>]+(>|$)/g, ""); // Elimina etiquetas HTML
		if (textContent.length > limit)
		{
			const truncatedText = textContent.substring(0, limit) + "...";
			return truncatedText;
		}
		return textContent;
	}


	const participate = () =>
	{
		setSending(true);

		if (selectedSavingPlan == undefined || selectedModelPortfolio == undefined)
		{
			return setHaveError(true);
		} else
		{

			const participationValues: CompetitionsUsersTypeElement = {
				competitionId: competitionId,
				savingsPlanId: selectedSavingPlan,
				portfolioModelId: selectedModelPortfolio ?? 0,
				userId: user.id
			};


			if (competition?.price == 0)
			{
				const participationValues: CompetitionsUsersTypeElement = {
					competitionId: competitionId,
					savingsPlanId: selectedSavingPlan,
					portfolioModelId: selectedModelPortfolio ?? 0,
					userId: user.id
				};

				CompetitionsService.inscribeInCompetition(participationValues)
					.then(
						(response: CompetitionsUsersType) =>
						{
							setIsModal(true);
							setShowModal(true);
						},
						(error: any) =>
						{
							setError({ status: true, message: error.response.data });
						}
					)
					.finally(() =>
					{
						setSending(false);
					});
			}
			else
			{
				if (competition?.typeOfPrice == 0 || competition?.typeOfPrice == 1)
				{
					const participationValues: CompetitionsUsersTypeElement = {
						competitionId: competitionId,
						savingsPlanId: selectedSavingPlan,
						portfolioModelId: selectedModelPortfolio ?? 0,
						userId: user.id
					};

					CompetitionsService.inscribeInCompetition(participationValues)
						.then(
							(response: CompetitionsUsersType) =>
							{
								setIsModal(true);
								setShowModal(true);
							},
							(error: any) =>
							{
								setError({ status: true, message: error.response.data });
							}
						)
						.finally(() =>
						{
							setSending(false);
						});
				} else
				{

					if (wantElements === false)
					{
						//el pago es en euros
						CompetitionsService.inscribeInCompetition(participationValues)
							.then(
								(response: CompetitionsUsersType) =>
								{
									if (!response || !response.id)
									{
										return setError({ status: true, message: "Se ha producido un error al guardar la información." });
									}

									if (competition?.typeOfPrice === 3)
									{
										const externalUrl = competition.urlPayment?.startsWith("http") ? competition.urlPayment : `https://${competition.urlPayment}`;
										window.open(externalUrl, "_blank");
										history.push(`/competition/${createurl(competition.name)}-${competition.id}`, { competitionId: competition.id });
									}
									else if (competition?.typeOfPrice === 2)
									{
										history.push("/competition/ap/contract", { competitionUserObject: response, competition: competition })
									}


								},
								(error: any) =>
								{
									setError({ status: true, message: error.response.data });
								}
							)
							.finally(() =>
							{
								setSending(false);
							});


					}

					if (wantElements === true)
					{
						//El pago es en elements
						CompetitionsService.inscribeInCompetitionWithElementsSelected(participationValues)
							.then(
								(response: CompetitionsUsersType) =>
								{
									if (!response || !response.id)
									{
										return setError({ status: true, message: "Se ha producido un error al guardar la información." });
									}

									if (competition?.typeOfPrice === 3)
									{
										const externalUrl = competition.urlPayment?.startsWith("http") ? competition.urlPayment : `https://${competition.urlPayment}`;
										window.open(externalUrl, "_blank");
										history.push(`/competition/${createurl(competition.name)}-${competition.id}`, { competitionId: competition.id });
									}
									else if (competition?.typeOfPrice === 2)
									{
										history.push("/competition/ap/contract", { competitionUserObject: response, competition: competition, wantElements: true })
									}

								},
								(error: any) =>
								{
									setError({ status: true, message: error.response.data });
								}
							)
							.finally(() =>
							{
								setSending(false);
							});
					}
				}
			}
		}
	};


	const handleToggleValueCompetitionChange = (
		event: React.MouseEvent<HTMLElement>,
		checked: boolean | undefined
	) =>
	{
		setWantElements(checked ?? false);
	};


	const includeCompetitionInLocalHost = async () =>
	{
		const competitionInfo: ICompetitionInfo = {
			name: competition!.name!,
			competitionId: competitionId,
			isPromotionated: competition!.isPromocionated!,
			origin: "participate"
		};

		var selectedPlan = savingsPlansWithData?.find(savingPlan => savingPlan.id == selectedSavingPlan);

		var item: any =
		{
			planId: selectedPlan?.id,
			planName: selectedPlan?.planName,
			userId: user.id,
			type: selectedPlan?.type,
			status: 4,
			outdated: selectedPlan?.outdated,
			outdatedContract: selectedPlan?.outdatedContract,
			cancelled: selectedPlan?.cancelled,
			portfolio: selectedPlan?.portfolio,
			finametrixContract: selectedPlan?.finametrixContract,
			userSubscriptionId: selectedPlan?.userSubscriptionId
		};

		Auth.setActivePlan(item);

		dispatch(addCompetition(competitionId));
		dispatch(addCompetitionData(competitionInfo));
		dispatch(cartState(CartModes.CREATE_MODEL_PORTFOLIO));
	}


	return (
		<DocumentTitle title="IronIA - Competiciones">
			<section className={`${styles.index}`}>
				<BackButton />
				<div className="ms-Grid-row">
					<div className="ms-Grid-col ms-sm12">
						<h2>Competiciones</h2>
					</div>
				</div>
				{loading && <Spinner size={SpinnerSize.large} />}
				{!loading && error.status && <div>Error: {error.message}</div>}
				{!loading && !error.status && (
					<div style={{ display: "flex" }}>
						<article style={{ display: "flex", justifyContent: "space-between", flexDirection: "column" }} className={`${styles.card_participate} rounded background-background`}>
							<div className="descriptioncompetition ms-Grid-col ms-sm12">
								{competition?.price != 0 && competition?.typeOfPrice == 0 && <> Si pulsa en participar se le restarán{" "} {currencyNeutreFormatter.format(competition.price)} de
									Elements IA.</>
								}
								{competition?.price != 0 && competition?.typeOfPrice == 1 && <>Si pulsa en participar se le restarán{" "} {currencyNeutreFormatter.format(competition.price)} de
									Elements Agua.</>
								}
								{(competition?.typeOfPrice == 2 || competition?.typeOfPrice == 3) && <div>
									<p>La competición tiene un precio de {currencyNeutreFormatter.format(competition?.price)}€ pero puedes pagar con elements si así lo deseas.</p>
									<p>Selecciona el tipo de pago que deseas:</p>
									<div style={{ display: "flex", width: "50%", marginTop: "20px" }}>
										<p style={{ marginRight: "5px" }}>{currencyNeutreFormatter.format(competition?.price)}€</p>
										<Toggle
											checked={wantElements}
											onChange={handleToggleValueCompetitionChange}
											style={{ backgroundColor: "#CC214F" }}
											styles={{
												thumb: {
													backgroundColor: "white",
												},
											}}
										/>
										<p style={{ marginLeft: "5px" }}>{currencyNeutreFormatter.format(competition?.price * 100)}{" "}Elements IA</p>
									</div>
								</div>
								}
								<p
									className="descriptioncompetition"
									style={{ marginBottom: "10px" }}
								>
									Selecciona la cartera modelo con la que deseas participar en
									la competición. La rentabilidad de la cartera durante el
									periodo de competición determinara a los ganadores.
								</p>

								{/* {((competition?.typeOfPrice === 0 || competition?.typeOfPrice === 1) && competition.type === 1) &&
									<p className="descriptioncompetition">
										Esta competición es a tres ganadores: el que más
										rentabilidad obtenga se lleva el 50% de los Elements de
										los participantes, el segundo el 30% y el tercero el 20%"{" "}
									</p>
								} */}
								<div style={{ display: "flex" }}>
									<S.CustomFieldPrefixCont>
										<S.Label>Plan de Cartera</S.Label>
										{/*//@ts-ignore */}
										<Select
											options={savingsPlans ?? []}
											placeholder=""
											onChange={(selectedOptions) =>
											{
												setSelectedSavingPlan(selectedOptions[0].value);
												setSelectedModelPortfolio(undefined);
												setSavingPlanModelPortfolios([]);
											}}
											searchable={false}
											required
											style={{ zIndex: 5 }}
										/>
									</S.CustomFieldPrefixCont>
									{savingsPlans == undefined && <div style={{ marginLeft: "20px", marginTop: "30px" }}>
										<Spinner size={SpinnerSize.small} style={{ marginTop: "60x" }} className="button-spinner" />
									</div>}
								</div>
								{haveError && selectedSavingPlan == undefined && (
									<p className="ms-Grid-col ms-sm6 ms-md6 ms-lg6 ms-xl6" style={{ color: "red" }}>
										Debes seleccionar un plan de cartera
									</p>
								)}
								<div className="ms-Grid-row" style={{ marginTop: "10px" }}>
									{!chargedModelPortfolio && <Spinner size={SpinnerSize.small} className="button-spinner ms-Grid-col ms-sm1 ms-md1 ms-lg1 ms-xl1 " />}
									{chargedModelPortfolio && selectedSavingPlan &&
										(
											savingsPlans && savingsPlans?.length > 0 ?
												savingPlanModelPortfolios == undefined
													|| (savingPlanModelPortfolios == undefined
														|| savingPlanModelPortfolios.length == 0)
													?
													<div style={{ marginTop: "10px" }}>
														<p style={{ marginBottom: "10px" }}>Pulsa en el botón Crear para crear la Cartera Modelo:</p>
														<Link to={"/cart"} className="color-black">
															<PrimaryButton
																//className="rounded"
																disabled={!savingsPlans || savingsPlans.length == 0}
																style={{
																	marginTop: "0px",
																	marginLeft: "8px",
																	marginRight: "3px",
																	width: "100px",
																	height: "40px",
																	borderRadius: "60px"
																}}
																onClick={includeCompetitionInLocalHost}
															>
																Crear
															</PrimaryButton>
														</Link>
													</div>
													:
													<div style={{ display: "flex", alignItems: "center" }}>
														{/*//@ts-ignore */}
														<S.CustomFieldPrefixCont>
															<S.Label>Cartera Modelo</S.Label>
															{/*//@ts-ignore */}
															<Select
																options={savingPlanModelPortfolios ?? []}
																placeholder=""
																onChange={(selectedOptions) =>
																{
																	setSelectedModelPortfolio(selectedOptions[0]?.value || undefined)
																}}
																values={
																	selectedModelPortfolio
																		? [
																			// Busca el label asociado al value seleccionado
																			{
																				value: selectedModelPortfolio,
																				label: savingPlanModelPortfolios?.find(
																					(portfolio) => portfolio.value === selectedModelPortfolio
																				)?.label || "", // Si no se encuentra, deja un string vacío
																			},
																		]
																		: []
																}
																searchable={false}
																required
																style={{ zIndex: 4 }}
															/>
														</S.CustomFieldPrefixCont>
														<Link to={"/cart"} className="color-black">
															<PrimaryButton
																//className="rounded"
																disabled={!savingsPlans || savingsPlans.length == 0}
																style={{
																	marginRight: "3px",
																	width: "100px",
																	height: "40px",
																	borderRadius: "60px",
																	marginLeft: "20px",
																	marginTop: "30px"
																}}
																onClick={includeCompetitionInLocalHost}
															>
																Crear
															</PrimaryButton>
														</Link>
													</div>
												: <></>)}
								</div>
								{haveError && selectedModelPortfolio == undefined && (
									<p className="ms-Grid-col ms-sm6 ms-md6 ms-lg6 ms-xl6" style={{ color: "red" }}>
										Debes seleccionar al menos una cartera modelo
									</p>
								)}
								{competition != undefined &&
									elementsAmount != undefined &&
									competition.typeOfPrice == 0 &&
									competition?.price > elementsAmount?.elementIA ? (
									<p style={{ color: "red", marginTop: "30px" }}>
										No puede participar en la competición ya que actualmente
										posee {elementsAmount?.elementIA} Elements IA y el precio
										por participar es de {competition?.price} Elements IA{" "}
									</p>
								) : (
									<></>
								)}
								{competition != undefined &&
									elementsAmount != undefined &&
									competition.typeOfPrice == 1 &&
									competition?.price > elementsAmount?.elementWater ? (
									<p style={{ color: "red", marginTop: "30px" }}>
										No puede participar en la competición ya que actualmente
										posee {elementsAmount?.elementWater} Elements Agua y el
										precio por participar es de {competition?.price} Elements
										Agua
									</p>
								) : (
									<></>
								)}

							</div>
							<div
								style={{
									display: "flex",
									justifyContent: "right",
									marginTop: "20px"
								}}
							>
								<DefaultButton
									className="button tiny-primary-button"
									onClick={() => history.push("/competitions")}
									disabled={sending}
								>
									Cancelar
								</DefaultButton>

								<DefaultButton
									className="button tiny-primary-button"
									type="submit"
									disabled={
										sending ||
										(competition != undefined &&
											elementsAmount != undefined &&
											competition.typeOfPrice == 1 &&
											competition?.price > elementsAmount?.elementWater) ||
										(competition != undefined &&
											elementsAmount != undefined &&
											competition.typeOfPrice == 0 &&
											competition?.price > elementsAmount?.elementIA) ||
										(selectedSavingPlan == undefined || selectedModelPortfolio == undefined)
									}
									onClick={participate}
								>
									{sending && (
										<Spinner
											size={SpinnerSize.small}
											className="button-spinner"
										/>
									)}
									Participar
								</DefaultButton>
							</div>
						</article>
						<div
							style={{
								display: "flex",
								flexDirection: "column",
								alignContent: "center",
								width: "50%",
							}}
						>
							<article
								className={`ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl3 rounded background-background`}
								style={{ alignSelf: "center" }}
							>
								{
									competition != undefined && <article
										className={`rounded background-background`}
										style={{
											marginRight: "20px",
											boxShadow: "0 0 5px 3px rgb(0 0 0 / 8%)",
											paddingTop: "10px",
											paddingLeft: "16px",
											paddingRight: "16px",
											height: "240px",
											width: "390px"
										}}
									>
										<header>
											<div
												style={{
													display: "flex",
													marginTop: "10px",
													height: "50px",
													alignContent: "center",
													justifyContent: "space-between",
												}}
											>
												<div style={{ display: "flex", flexDirection: "column" }}>
													<p
														style={{
															marginBottom: "0px",
															fontSize: "16px",
															fontWeight: "600",
															wordBreak: "break-word",
														}}
													>
														{competition?.name}
													</p>
													<span className="color-neutralTertiaryAlt">
														Del {formatDate(competition?.startDate)} al {formatDate(competition?.endDate)}
													</span>
												</div>
												<span className={styles.type}>
													Tipo: {CompetitionTypes[competition.type]}
												</span>
											</div>
										</header>
										<main
											style={{
												marginTop: "10px",
												whiteSpace: "normal",
												height: "100px"
											}}
											dangerouslySetInnerHTML={{
												__html: truncateHtml(competition.summary ?? "", 300),
											}}
										/>
										<div
											style={{
												position: "relative",
												width: "100%",
												height: "190px",
											}}
										>
											<footer
												style={{
													backgroundColor: "white",
													width: "100%",
													fontSize: "14px",
													fontWeight: "500",
													display: "flex",
													justifyContent: "space-between",
													boxSizing: "border-box",
												}}
											>
												<div>
													<span>
														{competition.price === 0 && <>Inscripción gratuita</>}
														{competition.price !== 0 && competition.typeOfPrice === 0 && <>{currencyNeutreFormatter.format(competition.price)} Elements IA</>}
														{competition.price !== 0 && competition.typeOfPrice === 1 && <>{currencyNeutreFormatter.format(competition.price)} Elements Agua</>}
														{competition.price !== 0 && (competition.typeOfPrice === 2 || competition.typeOfPrice === 3) && <>{currencyNeutreFormatter.format(competition.price)} €</>}
													</span>
													{competition.price != 0 && <> <p>Participantes: {competition.isPromocionated == true ? competition.competitionsUsers.filter(e => e.statusUserInCompetition === 1).length : competition.competitionsUsers.length}</p>
														<p className={styles.price}>
															Bote:{" "}
															{competition.typeOfPrice === 0 &&
																<>
																	{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.competitionsUsers.filter(e => e.statusUserInCompetition === 1).length)}{" "} Elements IA </>}
																	{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.competitionsUsers.length * competition.price)}{" "} Elements IA</>}
																</>
															}
															{competition.typeOfPrice === 1 &&
																<>
																	{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.competitionsUsers.filter(e => e.statusUserInCompetition === 1).length)}{" "} Elements Agua </>}
																	{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.competitionsUsers.length * competition.price)}{" "} Elements Agua</>}
																</>
															}
															{(competition.typeOfPrice === 2 || competition.typeOfPrice === 3) &&
																<>
																	{competition.isPromocionated === true && <> {currencyNeutreFormatter.format(competition.competitionsUsers.filter(e => e.statusUserInCompetition === 1).length)}{" "} € </>}
																	{competition.isPromocionated === false && <> {currencyNeutreFormatter.format(competition.competitionsUsers.length * competition.price)}{" "} €</>}
																</>
															}
														</p></>}
												</div>


											</footer>
											{/* {competition.price !== 0 && (
                    <footer
                        style={{
                            backgroundColor: "white",
                            width: "100%",
                            fontSize: "14px",
                            fontWeight: "500",
                            display: "flex",
                            justifyContent: "space-between",
                            padding: "0 10px",
                            boxSizing: "border-box",
                            paddingLeft: "20px",
                            paddingRight: "20px",
                            paddingTop: "20px",
                            position: "absolute",
                            bottom: "20px",
                        }}
                    >
                        
                    </footer>
                )} */}
										</div>
										<ErrorModal
											title="Tu Plan actual no es compatible con la competición"
											body={
												<div>
													<p>{error.message}</p>
												</div>
											}
											btnSubmitText="Aceptar"
											showModal={error.status}
											onSubmit={() =>
											{
												setError({ status: false, message: "" });
											}}
											onClose={() =>
											{
												setError({ status: false, message: "" });
											}}
										/>
									</article>
								}

							</article>
						</div>
						<ErrorModal
							title="Ha ocurrido un error al procesar tu solicitud"
							body={
								<div>
									<p>{error.message}</p>
								</div>
							}
							btnSubmitText="Aceptar"
							showModal={error.status}
							onSubmit={() =>
							{
								setError({ status: false, message: "" });
							}}
							onClose={() =>
							{
								setHaveError(false);
							}}
						/>
						{isModal && (
							<GenericMessageModalWithoutButton
								title="Inscripción registrada"
								body={
									competition != undefined ?
										<p> Tu inscripción ha sido registrada. Pulsa el boton aceptar para continuar.</p> :
										<p> Tu inscripción ha sido registrada. Pulsa el boton aceptar para continuar.</p>
								}
								btnSubmitText="Aceptar"
								showModal={showModal}
								onSubmit={() =>
								{
									setShowModal(false);
									history.push("/competitions");
								}}
								onClose={() =>
								{
									setShowModal(false);
									history.push("/competitions");
								}}
							></GenericMessageModalWithoutButton>
						)}
					</div>
				)}
			</section>
		</DocumentTitle>
	);
};

export default CompetitionParticipate;
